<template>
  <div>
    <b-modal id="addIntegration" scrollable hide-footer hide-header size="lg">
      <AddIntegModal />
    </b-modal>

    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="modal-spinner"
      style="margin-top: 200px; margin-inline-start: 450px"
    />

    <template v-else>
      <VpFormLayout>
      <template v-slot:content-header>
        <Breadcrumb style="background-color: transparent" :items="items" />
      </template>
        <template v-slot:content-body>
          <section class="dashboard-grid white-bg-sec">
            <b-row>
              <b-col cols="8">
                <b-row>
                  <b-col
                    cols="2"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <img
                      v-if="intgDirectory"
                      :src="require('@/assets/images/' + intgDirectory.img_url)"
                      alt="directory img"
                      height="42"
                    />
                  </b-col>
                  <b-col
                    cols="5"
                    class="text-left d-flex flex-column align-items-start"
                  >
                    <h3>{{ getIntgDataMapping.name }}</h3>
                    <p>{{ tenantId }}</p>
                    <p
                      class="custom-sizes"
                      :class="{
                        'text-blue': getIntgStatus == 'Draft',
                        'text-success':
                          getIntgStatus == 'Active' ||
                          (getIntgStatus &&
                            getIntgStatus
                              .toLowerCase()
                              .replace(/^./, getIntgStatus[0].toUpperCase()) ==
                              'Active with errors'),
                        'text-danger':
                          getIntgStatus == 'Inactive' ||
                          (getIntgStatus &&
                            getIntgStatus
                              .toLowerCase()
                              .replace(/^./, getIntgStatus[0].toUpperCase()) ==
                              'Authentication failed') ||
                          getIntgStatus == 'Invalid',
                      }"
                    >
                      {{
                        getIntgStatus &&
                        getIntgStatus.toLowerCase() == "active with errors"
                          ? $t("integrations.active")
                          : $t(`integrations.${getIntgStatus.toLowerCase()}`)
                      }}
                    </p>
                    <div
                      class="last_sync"
                      v-if="
                        getIntgStatus != 'Draft' && getIntgDataMapping.last_sync
                      "
                    >
                      <p>{{ $t('integrations.grid.lastSynced') }}</p>
                      <p>{{ convertToBrowserTime(getIntgDataMapping.last_sync) }}</p>
                    </div>
                    <div
                      class="last_sync"
                      v-if="getIntgDataMapping.dir_code == 'wonde'"
                    >
                    <p><b>{{ $t('common.notes.note') }}:</b></p>
                      <p>{{ $t('integrations.appearNote') }}</p>
                    </div>
                  </b-col>
                  <b-col cols="5" class="align-items-center">
                    <!-- <div class="page-title-right mb-2 d-flex"> -->
                    <b-button
                      pill
                      class="d-flex align-items-center justify-content-center top-page-btn"
                      variant="primary"
                      size="sm"
                      style="margin-bottom: 18px; width: 192px; height: 39px"
                      v-if="
                        getIntgStatus &&
                        getIntgStatus
                          .toLowerCase()
                          .replace(/^./, getIntgStatus[0].toUpperCase()) !=
                          'Authentication failed' &&
                        getIntgStatus != 'Invalid'
                      "
                      :disabled="getLoading"
                      @click="
                        startAutoSync({
                          id: getIntegId,
                          name: $route.params.integName,
                          redirectToView: false,
                        })
                      "
                    >
                      <!-- <i class="bx bx-plus font-size-18 mr-2"></i> -->
                      <div class="sync-icon" style="padding-inline-end: 13px">
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 8.50029C17 12.563 13.6094 16.9066 8.54709 16.9066C6.4633 16.8949 4.45014 16.1222 2.9079 14.7289L2.94321 16.2159C2.95499 16.6373 2.61357 16.9886 2.18975 17.0003H2.16621C1.74238 17.0003 1.40097 16.6725 1.3892 16.251L1.30679 12.8205C1.22438 12.5513 1.30679 12.2586 1.49515 12.0595C1.69529 11.8605 1.98961 11.7902 2.26039 11.8605L5.70983 11.9424C6.13366 11.9542 6.47507 12.3054 6.4633 12.7269C6.45152 13.1484 6.09834 13.4879 5.67452 13.4762L3.79086 13.4294C4.93283 14.4714 6.56925 15.3495 8.53532 15.3495C10.4543 15.3612 12.2909 14.5416 13.5741 13.1132C14.7396 11.8254 15.446 10.0926 15.446 8.48859C15.446 8.0671 15.7874 7.71586 16.223 7.71586C16.6586 7.71586 17 8.07881 17 8.50029ZM14.8103 0.000293959C15.2341 -0.011414 15.5873 0.328118 15.599 0.749605L15.6814 4.18005C15.7639 4.44933 15.6814 4.74203 15.4813 4.94106C15.2812 5.1401 14.9868 5.21035 14.7161 5.1401L11.2666 5.05815C10.8428 5.04644 10.5014 4.6952 10.5132 4.27371C10.5249 3.85222 10.8781 3.51269 11.3019 3.5244L13.1856 3.57123C12.0554 2.51751 10.419 1.63941 8.45291 1.63941C6.52216 1.6277 4.6856 2.44726 3.41413 3.87564C2.24862 5.16352 1.54224 6.8963 1.54224 8.50029C1.54224 8.92178 1.20083 9.27302 0.765235 9.27302C0.32964 9.27302 0 8.92178 0 8.50029C0 4.44933 3.39058 0.105666 8.45291 0.105666C10.5367 0.117374 12.5499 0.890101 14.0921 2.28335L14.0568 0.796437C14.0568 0.597401 14.1274 0.398366 14.2687 0.246162C14.41 0.0939579 14.5983 0.000293959 14.8103 0.000293959Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <span
                        style="
                           
                          
                          font-weight: 400;
                          font-size: 16px;
                          line-height: 19px;
                          text-align: center;

                          color: #ffffff;
                        "
                        >{{ $t('integrations.forceSyncNow')}}</span
                      >
                    </b-button>
                    <b-button
                      pill
                      class="d-flex new-width custom-primary"
                      variant="outline-primary"
                      size="sm"
                      style="margin-bottom: 18px; width: 192px; height: 39px"
                      v-if="getIntgStatus == 'Inactive'"
                      @click="showModal('Active', 'Reactivate', 'reactivating')"
                    >
                      {{ $t('integrations.reactivate') }}
                    </b-button>

                    <b-button
                      pill
                      style="
                        margin-bottom: 18px;
                        width: 192px;
                        height: 39px;
                        margin-top: 40px;
                      "
                      class="d-flex new-width"
                      variant="primary"
                      size="sm"
                      v-if="
                        getIntgStatus &&
                        getIntgStatus
                          .toLowerCase()
                          .replace(/^./, getIntgStatus[0].toUpperCase()) ==
                          'Authentication failed'
                      "
                      v-b-modal="'addIntegration'"
                      @click="reAuthenticate()"
                    >
                      <span
                        style="
                           
                          
                          font-weight: 400;
                          font-size: 16px;
                          line-height: 19px;
                          text-align: center;

                          color: #ffffff;
                        "
                        >{{ $t('integrations.reAuthenticate') }}</span
                      >
                    </b-button>

                    <b-button
                      pill
                      style="margin-bottom: 18px; width: 192px; height: 39px"
                      class="d-flex new-width custom-danger"
                      variant="outline-danger"
                      size="sm"
                      v-if="
                        getIntgStatus == 'Active' ||
                        (getIntgStatus &&
                          getIntgStatus
                            .toLowerCase()
                            .replace(/^./, getIntgStatus[0].toUpperCase()) ==
                            'Active with errors')
                      "
                      @click="showModal('Inactive', 'Deactivate', 'deactivating')"
                    >
                      {{ $t('integrations.deactivate') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <div class="break"></div>

            <b-row>
              <b-col cols="7">
                <b-row>
                  <b-col cols="2"></b-col>
                  <b-col cols="5">
                    <div>
                      <h5 class="">
                        {{
                          getIntgDataMapping.dir_code == "wonde" ? $t("integrations.mappedStudentFields") : $t("integrations.mappedFields")
                        }}
                      </h5>
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="5">
                <div>
                  <h5 class="">
                    {{
                      getIntgDataMapping.dir_code == "wonde" ? $t("integrations.mappedStudentGroups") : $t("integrations.mappedGroups")
                    }}
                  </h5>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="7">
                <b-row>
                  <b-col cols="2"></b-col>

                  <b-col cols="4">
                    <div
                      v-for="field in getIntgDataMapping.fields_mappings"
                      :key="field.id"
                      class="d-flex justify-content-between mb-2 mapping-fields"
                    >
                      <b-form-input
                        v-if="field.cloud_fields.obj_Name !== 'user_id'"
                        class="grouping"
                        :value="field.dir_fields.display_Name"
                        readonly
                      />

                      <div
                        class="icon-style d-flex"
                        v-if="field.cloud_fields.obj_Name !== 'user_id'"
                      >
                        <b-col class="grouping" cols="2">
                          <b-icon icon="link"></b-icon>
                        </b-col>
                      </div>

                      <b-form-input
                        v-if="field.cloud_fields.obj_Name !== 'user_id'"
                        class="grouping"
                        :value="field.cloud_fields.display_Name"
                        readonly
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="5">
                <b-row>
                  <b-col cols="5">
                    <div
                      v-for="group in getIntgDataMapping.groups_mappings"
                      :key="group.id"
                      class="d-flex justify-content-between mb-2 mapping-fields"
                    >
                      <template v-if="!checkIfStaffGroup(group.dir_group_id)">
                        <b-form-input
                          class="grouping"
                          :value="group.dir_group_name"
                          readonly
                        />

                        <div class="icon-style d-flex">
                          <b-col class="grouping" cols="2">
                            <b-icon icon="link"></b-icon>
                          </b-col>
                        </div>

                        <b-form-input
                          class="grouping"
                          :value="group.role.name"
                          readonly
                        />
                      </template>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <template
              v-if="
                getIntgDataMapping.areas_mappings &&
                getIntgDataMapping.areas_mappings.length > 0
              "
            >
              <div class="break"></div>
              <b-row>
                <b-col cols="7">
                  <b-row>
                    <b-col cols="2"></b-col>
                    <b-col cols="5">
                      <div>
                        <h5 class="">{{ $t("integrations.mappedStudentArea") }}</h5>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="7">
                  <b-row>
                    <b-col cols="2"></b-col>

                    <b-col cols="4">
                      <div
                        v-for="area in getIntgDataMapping.areas_mappings"
                        :key="area.area.id"
                        class="d-flex justify-content-between mb-2 mapping-fields"
                      >
                        <template v-if="getIntgDataMapping.dir_code != 'wonde'">
                          <b-form-input
                            class="grouping"
                            :value="
                              area.dir_area_name +
                              ' (' +
                              area.dir_doors_number +
                              ' door)'
                            "
                            readonly
                          />

                          <div class="icon-style d-flex">
                            <b-col class="grouping" cols="2">
                              <b-icon icon="link"></b-icon>
                            </b-col>
                          </div>
                        </template>

                        <b-form-input
                          class="grouping"
                          :value="area.area.name"
                          readonly
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>

            <template
              v-if="
                getIntgDataMapping.dir_int_extra_settings &&
                getIntgDataMapping.dir_int_extra_settings.length > 0
              "
            >
              <div class="break"></div>
              <template>
                <div
                  v-for="setting in getIntgDataMapping.dir_int_extra_settings"
                  :key="setting.type"
                >
                  <b-row>
                    <b-col cols="7">
                      <b-row>
                        <b-col cols="2"></b-col>
                        <b-col cols="5">
                          <div>
                            <h5 class="">{{ $t("integrations.mappedStaffFields") }}</h5>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="5">
                      <div>
                        <h5 class="">{{ $t("integrations.mappedStaffGroups") }}</h5>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="7">
                      <b-row>
                        <b-col cols="2"></b-col>

                        <b-col cols="4">
                          <div
                            v-for="field in setting.fields"
                            :key="field.id"
                            class="d-flex justify-content-between mb-2 mapping-fields"
                          >
                            <b-form-input
                              class="grouping"
                              :value="field.dir_fields.display_Name"
                              readonly
                            />

                            <div class="icon-style d-flex">
                              <b-col class="grouping" cols="2">
                                <b-icon icon="link"></b-icon>
                              </b-col>
                            </div>

                            <b-form-input
                              class="grouping"
                              :value="field.cloud_fields.display_Name"
                              readonly
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="5">
                      <b-row>
                        <b-col cols="5">
                          <div
                            v-for="group in getIntgDataMapping.groups_mappings"
                            :key="group.id"
                            class="d-flex justify-content-between mb-2 mapping-fields"
                          >
                            <template v-if="checkIfStaffGroup(group.dir_group_id)">
                              <b-form-input
                                class="grouping"
                                :value="group.dir_group_name"
                                readonly
                              />

                              <div class="icon-style d-flex">
                                <b-col class="grouping" cols="2">
                                  <b-icon icon="link"></b-icon>
                                </b-col>
                              </div>

                              <b-form-input
                                class="grouping"
                                :value="group.role.name"
                                readonly
                              />
                            </template>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>
              </template>
            </template>

            <div class="break"></div>
            <div
              class="parent d-flex align-items-center"
              style="margin-bottom: 50px; margin-inline-start: 46px"
            >
              <div>
                <span class="sync-list" style="margin-inline-end: 33px">
                  {{ $t('integrations.syncedList')}}</span
                >
              </div>
              <div class="sync-logs">
                <b-button
                  pill
                  class="d-flex align-items-center px-3 top-page-btn btn-style"
                  variant="primary"
                  size="sm"
                  style="
                    background-color: #2680eb !important;
                    border-color: #2680eb !important;
                    height: 29px;
                  "
                  @click="openSyncLogs()"
                >
                  {{ $t('integrations.syncLogs') }}
                </b-button>
              </div>
            </div>

            <div class="cards-con d-flex grouping">
              <div class="row">
                <div class="container d-flex grouping">
                  <div class="col-3" style="height: 187px">
                    <b-card class="card-style grouping" style="align-items: center">
                      <div class="head-style">
                        <h4>{{ $t('integrations.synced').toUpperCase() }}</h4>
                      </div>
                      <p class="viewCount">{{ getSyncedUsersCount }}</p>
                      <p class="view-user">{{ $t('integrations.users') }}</p>
                      <div class="view-style">
                        <b-button
                          pill
                          class="d-flex justify-content-center align-items-center px-3 top-page-btn"
                          variant="primary"
                          size="sm"
                          :disabled="getSyncedUsersCount <= 0"
                          @click="redirectUser('valid')"
                        >
                          <!-- <i class="bx bx-plus font-size-18 mr-2"></i> -->
                          {{ $t('common.view') }}
                        </b-button>
                      </div>
                    </b-card>
                  </div>
                  <div class="col-1 diffrent"></div>

                  <div class="col-3" style="height: 187px">
                    <b-card class="card-style grouping" style="align-items: center">
                      <div class="head-style">
                        <h4>{{ $t('common.duplicates').toUpperCase() }}</h4>
                      </div>
                      <p class="viewCount">{{ getUsersWithDuplicatesCount }}</p>
                      <p class="view-user">{{ $t('integrations.users') }}</p>
                      <div class="view-style">
                        <b-button
                          pill
                          class="d-flex d-flex justify-content-center grouping align-items-center px-3 top-page-btn"
                          variant="primary"
                          size="sm"
                          :disabled="dupLoading || getUsersWithDuplicatesCount <= 0"
                          @click="redirectUser('duplicate')"
                        >
                          <i
                          v-if="dupLoading"
                          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
                        ></i>
                          {{dupLoading ? "" : $t('common.view') }}
                        </b-button>
                      </div>
                    </b-card>
                  </div>
                  <div class="col-1 diffrent"></div>
                  <div class="col-3" style="height: 187px">
                    <b-card class="card-style grouping" style="align-items: center">
                      <div class="head-style">
                        <h4>{{ $t('common.errors').toUpperCase() }}</h4>
                      </div>
                      <p class="viewCount">{{ getUsersWithErrsCount }}</p>
                      <p class="view-user">{{ $t('integrations.users') }}</p>
                      <div class="view-style d-flex">
                        <b-button
                          pill
                          class="grouping d-flex justify-content-center align-items-center px-3 top-page-btn"
                          variant="primary"
                          size="sm"
                          :disabled="getUsersWithErrsCount <= 0"
                          @click="redirectUser('error')"
                        >
                          <!-- <i class="bx bx-plus font-size-18 mr-2"></i> -->
                          {{ $t('common.view') }}
                        </b-button>
                      </div>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </template>
      </VpFormLayout>
    </template>

      <!-- sync logs  -->
      <b-modal
        id="syncLogsModal"
        scrollable
        size="lg"
        class=""
        hide-header
        hide-footer
        no-close-on-esc
        @hide="$bvModal.hide('syncLogsModal')"
      >
        <slot name="modal-header">
          <div class="d-flex justify-content-center">
            <h5
              class="modal-title align-items-center"
              style="color: #000000; text-align: center"
            >
              <slot name="modal-title">
                <span class=""> {{$t('integrations.syncLogs')}} </span>
              </slot>
            </h5>
            <div class="header-close-style d-flex align-items-center">
              <div class="closing-design">
                <svg
                  @click="$bvModal.hide('syncLogsModal')"
                  style="cursor: pointer; margin-bottom: 41px"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                    fill="#F46A6A"
                  />
                </svg>
              </div>
            </div>
          </div>
        </slot>
        <div class="table-style">
          <DxDataGrid
            :data-source="allSyncLogs"
            :remote-operations="false"
            :showBorders="false"
            :columnAutoWidth="true"
            :allowColumnReordering="false"
            :allowColumnResizing="true"
            :rowAlternationEnabled="true"
            :showColumnLines="true"
            :showRowLines="true"
            :wordWrapEnabled="false"
            :rtl-enabled="rtlEnabled"
          >
            <!-- <DxEditing :use-icons="true" :allow-updating="true" :allow-adding="false" :allow-deleting="false" mode="row" /> -->
            <DxScrolling mode="standard" :use-native="!rtlEnabled" />

            <DxPaging :page-size="10" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="[10, 25, 50, 100, 'all']"
              :display-mode="'full'"
              :show-page-size-selector="true"
              :show-info="true"
              :show-navigation-buttons="true"
              :infoText="$t('common.page')"
            />

            <!-- <DxSelection mode="multiple"/> -->

            <!-- <DxFilterRow :visible="true" /> -->
            <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

            <DxHeaderFilter :visible="true" />

            <!-- <DxSearchPanel :visible="true" placeholder="Search..." /> -->

            <!-- <DxGrouping :context-menu-enabled="true" /> -->
            <!-- <DxGroupPanel :visible="true" /> -->

            <DxColumn data-field="generate_time" :caption="$t('integrations.syncDate')" />

            <DxColumn data-field="sync_method" :caption="$t('integrations.syncMethod')" />

            <DxColumn
              :calculate-cell-value="getFullName"
              :allow-header-filtering="true"
              :allow-sorting="true"
              :caption="$t('common.by')"
            />

            <DxColumn :caption="$t('common.grid.action')" cell-template="action-cell" />

            <template #action-cell="{ data }">
              <b-button
                pill
                class="d-flex align-items-center px-3 top-page-btn"
                variant="primary"
                size="sm"
                @click="download(data.data)"
              >
                {{$t('common.download')}}
              </b-button>
            </template>
          </DxDataGrid>
          <!-- <table
          class="table table-striped table-borderless"
          style="margin-top: 40px"
        >
          <thead>
            <tr
              style="
                border-bottom: 20px solid white !important;
                border-radius: 5px;
              "
            >
              <th scope="col " style="text-align: start; width: 10rem">
                <sort-link name="id">Sync Date</sort-link>
              </th>
              <th scope="col" style="text-align: start; width: 10rem">
                <sort-link name="name">Sync Method</sort-link>
              </th>
              <th scope="col" style="text-align: start; width: 10rem">
                <sort-link name="hits">By Whom</sort-link>
              </th>
              <th scope="col" style="text-align: start; width: 10rem">
                <sort-link name="hits">Actions</sort-link>
              </th>
            </tr>
          </thead>
          <template>
            <tbody>
              <tr
                style="border-bottom: 20px solid white !important"
                v-for="(log, index) in getSyncLogs"
                :key="index"
              >
                <td style="">{{ log.created_at }}</td>
                <td>{{ log.sync_method }}</td>
                <td>{{ log.run_by ? log.run_by.first_name : '' }} {{ log.run_by ? log.run_by.last_name : '' }}</td>
                <td>
                  <b-button
                    pill
                    class="d-flex align-items-center px-3 top-page-btn"
                    variant="primary"
                    size="sm"
                    @click="download(log)"
                  >
                    Download
                  </b-button>
                </td>
              </tr>
            </tbody>
          </template>
        </table> -->
        </div>
      </b-modal>

      <!-- warning  -->
      <b-modal
        id="actionWarning"
        class="popover-modal"
        hide-header
        hide-footer
        no-close-on-esc
        ref="actionWarning"
      >
        <slot name="modal-header">
          <div class="modalHeader">
            <h4 class="modal-title">
              <slot name="modal-title"> {{ $t(`integrations.${changedStatus.toLowerCase()}`) }} {{$t(`integrations.integration`)}} </slot>
            </h4>
          </div>
        </slot>
        <div class="d-block text-center modal-cusomContent">
          <p class="modal-paragraph">
            {{ $t('common.notes.areYouSureYouWant') }} <span class="bold-word">
              “{{ $t(`integrations.${changedStatus.toLowerCase()}`) }} ” </span
            >{{ $t("integrations.thisIntg") }}
          </p>
          <p
            class="modal-smallParagraph"
            v-if="changedStatusVerb == 'deactivating'"
          >
            {{ $t("integrations.byDeactivatingMsg", { verb: $t(`integrations.${changedStatusVerb.toLowerCase()}`) }) }}
          </p>

          <p
            class="modal-smallParagraph"
            v-if="changedStatusVerb == 'reactivating'"
          >
            {{ $t("integrations.byReactivatingMsg", { verb: $t(`integrations.${changedStatusVerb.toLowerCase()}`) }) }}
          </p>
        </div>
        <div class="line"></div>
        <div class="action-btns" v-if="changedStatus == 'Reactivate'">
          <b-button
            variant="primary"
            type="button"
            pill
            :disabled="getLoading"
            style="margin-inline-end: 31px !important"
            class="text-center modal-buttonSize"
            @click="changeIntegStatus('Active')"
          >
            {{ $t(`integrations.${changedStatus.toLowerCase()}`) }}
          </b-button>

          <b-button
            variant="outline-danger modal-buttonSize"
            type="button"
            pill
            :disabled="getLoading"
            class="text-center"
            @click="$bvModal.hide('actionWarning')"
          >
          {{ $t(`common.cancel`) }}
          </b-button>
        </div>

        <div class="action-btns" v-if="changedStatus == 'Deactivate'">
          <b-button
            variant="primary"
            type="button"
            pill
            :disabled="getLoading"
            style="margin-inline-end: 31px !important"
            class="text-center modal-buttonSize"
            @click="$bvModal.hide('actionWarning')"
          >
          {{ $t(`common.cancel`) }}
          </b-button>

          <b-button
            variant="outline-danger"
            type="button"
            pill
            :disabled="getLoading"
            class="text-center modal-buttonSize"
            @click="changeIntegStatus('Inactive')"
          >
            {{ $t(`integrations.${changedStatus.toLowerCase()}`) }}
          </b-button>
        </div>
      </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import router from "../../../router/index";
import AddIntegModal from "@/components/integration/AddIntegModal";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import { mapActions, mapGetters } from "vuex";
// const dataGridRef = "dataGrid";
import DxDataGrid, {
  DxColumn,
  DxPaging,
  DxScrolling,
  DxPager,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
export default {
  title: "Integration",
  components: {
    Breadcrumb,
    AddIntegModal,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    DxScrolling
  },
  data() {
    return {
      rtlEnabled: false,
      intgDirectory: null,
      changedStatus: "",
      changedStatusVerb: "",
      imgUrl: "",
      tenantId: "",
      groupTextFields: [
        {
          id: "item.id",
          name: "item.name",
          bindValue: "",
        },
      ],
      items: [
        {
          text: this.$t("sideNavbarMenu.integration.text"),
          to: { name: "addIntegration" },
        },
        {
          text: this.$route.params.integName,
          to: {
            name: "viewIntegration",
            params: {
              integId: this.$route.params.integId,
              integName: this.$route.params.integName,
            },
          },

          active: true,
        },
      ],
      title: "Integrations",
      cards: [],
      allSyncLogs: [],
      isLoading: false,
      dupLoading: false,
    };
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("integration", [
      "fetchDirectoryList",
      "fetchGridIntegrationData",
      "resetIntgData",
      "getIntegrationWithMapping",
      "awaitIntegrationWithMapping",
      "getIntegration",
      "fetchTempUsersWithDuplicates",
      "fetchTempUsersWithErrors",
      "fetchSyncedUsers",
      "getIntegrationStat",
      "changeIntegrationStatus",
      "setReAuth",
      "startAutoSync",
      "getSyncLogsList",
      "checkDuplicate",
    ]),

    checkIfStaffGroup(id) {
      if (
        this.getIntgDataMapping.dir_int_extra_settings &&
        this.getIntgDataMapping.dir_int_extra_settings[0]
      ) {
        const userTypes = JSON.parse(
          this.getIntgDataMapping.dir_int_extra_settings[0].condition
        ).user_type;
        if (userTypes.includes(id)) return true;
      }
      return false;
    },

    getFullName(rowData) {
      return rowData.sync_method == "Manual" && rowData.run_by
        ? rowData.run_by.email == "lt_techteam@visipoint.com"
          ? "Admin - CS"
          : rowData.run_by.first_name + " " + rowData.run_by.last_name
        : rowData.sync_method == "Automatic"
        ? "System"
        : "";
    },

    convertToBrowserTime(time) {
        if (this.getLanguage === "ar")
        return moment(new Date(time + " UTC")).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(time + " UTC")).format("A") === "AM" ? " ص" : " م");

          return moment(new Date(time + " UTC")).format("DD/MM/YYYY - h:mm:ss A");
      // date.toString()
    },

    download(log) {
      window.open(
        `${process.env.VUE_APP_INTEGRATION_URL}/${log.file_name}`,
        "_blank"
      );
    },

    redirectUser(data) {
      if (data == "duplicate") {
        this.dupLoading = true;
        this.checkDuplicate({
          id: this.$route.params.integId,
          redirectToDuplicate: true,
        });
      } else router.push("/integration-" + data);
      this.$store.dispatch("integration/setFromView", true);
    },

    showModal(status, action, verb) {
      console.log("sowmodal");
      this.changedStatus = action;
      this.changedStatusVerb = verb;
      this.$bvModal.show("actionWarning");
    },

    changeIntegStatus(status) {
      this.changeIntegrationStatus({
        integId: this.$route.params.integId,
        status,
      });
      this.$bvModal.hide("actionWarning");
    },

    reAuthenticate() {
      this.setData(this.intgDirectory);
      this.setReAuth(true);
    },

    openSyncLogs() {
      console.log("getSyncLogs", this.getSyncLogs);
      this.allSyncLogs = JSON.parse(JSON.stringify(this.getSyncLogs));
      this.allSyncLogs.map(
        (item) =>
          (item.generate_time = item.generate_time
            ? (
              this.getLanguage === "ar" ? moment(new Date(item.generate_time + " UTC")).locale('en') // Ensures numbers remain in English
          .format("DD/MM/YYYY - h:mm:ss") + 
          (moment(new Date(item.generate_time + " UTC")).format("A") === "AM" ? " ص" : " م")
          : moment(new Date(item.generate_time + " UTC")).format("DD/MM/YYYY - h:mm:ss A"))
            : "")
      );
      this.$bvModal.show("syncLogsModal");
    },
  },
  watch: {
    getIntgStatus(val) {
      console.log("getIntgStatus", val);
    },
  },
  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("integration", [
      "getLoading",
      "getDirectoryList",
      "getGridIntegrationData",
      "getIntegId",
      "getIntgDataMapping",
      "getIntgStatus",
      "getUsersWithDuplicatesCount",
      "getUsersWithErrsCount",
      "getSyncedUsersCount",
      "getSyncLogs",
      "getFromView",
      "getDecryptedEmail",
    ]),

    integId() {
      console.log("intg", this.$route.params.integId);
      return this.$route.params.integId;
    },
  },
  async beforeMount() {
    if (this.getLanguage === "ar") {
      this.rtlEnabled = true;
    }
    document.getElementById("preloader")
      ? (document.getElementById("preloader").style.display = "none")
      : "";
    document.getElementById("preloader")
      ? (document.getElementById("status").style.display = "none")
      : "";
    this.fetchDirectoryList();
    this.fetchGridIntegrationData();
    this.getSyncLogsList(this.$route.params.integId);
    //---------------------------------------------------------------
    console.log(
      "before",
      this.$route.params.integId,
      this.$route.params.integName
    );
    this.isLoading = true;
    await this.getIntegration({
      id: this.$route.params.integId,
    });

    this.getIntegrationWithMapping({
      id: this.$route.params.integId,
      name: this.$route.params.integName,
      redirect: false,
    }).then((data) => {
      this.isLoading = false;

      this.intgDirectory = this.getDirectoryList.find(
        (item) => item.code == data.dir_code
      );

      this.tenantId =
        data.dir_code == "googleAD"
          ? data.extra_data && data.extra_data[0]
            ? data.extra_data[0].email
            : ""
          : data.dir_unique_id;

      this.imgUrl = this.intgDirectory.img_url;
    });

    // this.fetchTempUsersWithErrors(this.$route.params.integId);
    // this.fetchTempUsersWithDuplicates(this.$route.params.integId);
    // this.fetchSyncedUsers(this.$route.params.integId);
    // this.checkDuplicate({ id: this.$route.params.integId, fromView: true });
    this.getIntegrationStat(this.$route.params.integId);

    // this.resetIntgData();
    // this.getIntegrationWithMapping({ id: this.$route.params.integId });
    console.log(
      "viewpage",
      this.$route.params.integId,
      this.getIntgDataMapping,
      this.getDirectoryList,
      this.getSyncedUsersCount
    );

    console.log("intgDirectory", this.intgDirectory);
    // const tenantConfig = this.getIntgDataMapping.configs.find(
    //   (item) => item.Key_code == "tenant_id"
    // );
  },
  mounted() {},
  created() {
    // document.addEventListener("mousedown", (e) => {
    //   if (e.path) {
    //     // console.log("path", e.path);
    //     let isColumnChooser = false;
    //     for (let i = 0; i < e.path.length; i++) {
    //       if (typeof e.path[i].matches == "function") {
    //         if (e.path[i].matches(".dx-overlay-content")) {
    //           isColumnChooser = true;
    //         }
    //       }
    //     }
    //     if (!isColumnChooser) this.dataGrid.hideColumnChooser();
    //   }
    // });
  },
};
</script>
<style lang="scss" scoped>
.custom-sizes {
  
  
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 19px !important;

  .text-danger {
    color: #f46a6a !important;
  }

  .text-success {
    color: #34c38f;
  }
}

.custom-sizes.text-blue {
  color: #2680eb !important;
}

.view-user {
  
  
  font-weight: 900;
  font-size: 13px;
  line-height: 16px;
  color: #000000;
  opacity: 0.2;
  margin-bottom: 14px;
}

.section {
  // position: absolute;
  display: flex;
  justify-content: center;
  width: 919px;
  height: 289px;
  background: #f3f3f3;
  border-radius: 18px;
}

.viewCount {
  height: 49px;
  text-align: center;
  margin-bottom: 0px !important;
  
  font-weight: 900;
  font-size: 41px;
  line-height: 49px;
  color: #103f5e;
}

.width-32 {
  width: 32%;
}

.mapping-fields input {
  
  
  font-weight: 700;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #787878;
}

.new-width {
  width: 160px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.custom-danger {
  
  
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: end;
  color: #f46a6a;
  border: 2.5px solid #f46a6a;
  border-radius: 19.5px;
}

.custom-danger:hover {
  color: #ffffff !important;
}

.custom-primary {
  border: 2.5px solid #103f5e;
  border-radius: 19.5px;
  
  
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;

  :hover {
    color: #ffffff;
  }
}

.width-45 {
  width: 45%;
}

.dark-grey {
  color: #939393;
}

.light-grey {
  color: #c7c7c7;
}

.mapping-fields {
  label {
    background-color: #f2f2f2;
    width: 90px;
    height: 100%;
    margin-inline-end: 5px;
    border-radius: 7px;
    text-align: center;
    color: #787878;
    font-size: 11px;
    font-weight: bold;
    padding-top: 5px;
  }

  input {
    color: #787878;
    font-size: 16px;
    font-weight: 600;
  }
}

.field-map-wrap {
  .key-field {
    display: inline-block;
    background-color: #f2f2f2;
    height: 57px;
    margin-inline-end: 5px;
    padding: 14px 15px;
    border-radius: 4px;
    color: #787878;
    font-size: 16px;
  }

  .input-wrapper {
    display: inline-block;
    width: 100%;
  }
}

.wrapper {
  background-color: white;
  padding-inline-start: 30px;
  padding-top: 32px;
  border-radius: 5px;
  padding-bottom: 30px;
  padding-inline-end: 30px;

  .content {
    margin-top: 0px;
  }
}

.form-control {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  width: 173px;
  height: 55px;
  inset-inline-start: 379px;
  top: 472px;
  border-radius: 8px;
}

.custom-tag .form-control {
  background-color: white;
  border: 0px;
  padding: 0px;
}

.custom-tag .form-control .custom-select {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
  color: #797d91;
  width: 31.7%;
}

i.mdi-arrow-right-box {
  font-size: 24px;
  padding: 0px;
  color: black;
}

@import "@/design/user_form_modals.scss";

.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}

.delete-icon {
  font-size: 1.3rem;
  margin-inline-start: 8px;
  cursor: pointer;
}

.user-types-select {
  z-index: 1100;
}

.user-roles {
  z-index: 999;
}

p {
  display: block;
  color: #939393;
}

// .header-close-style {
//   width: 22px;
//   height: 22px;
//   border-radius: 50%;
//   justify-content: center;
//   justify-items: center;
//   inset-inline-start: 70.21%;
//   inset-inline-end: 28.26%;
//   top: 33.67%;
//   bottom: 63.89%;

//   background: #f46a6a !important;
// }

.header-close:active {
  outline: none;
}

.text-700 {
  font-weight: 700;
}

h3 {
  font-weight: 700;
  font-size: 18px;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: #000000;
}

h4 {
  font-weight: bold;
  color: #c7c7c7;
  font-size: 14px !important;
}

p {
  font-size: 12px;
  color: black;
  font-weight: bold;
}

.last_sync {
  display: flex;
  gap: 3px;
  p {
    
    
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 0px;
    color: #c7c7c7;
  }
}

img {
  height: 42px;
}

.mdi-plus-circle {
  font-size: 24px;
  color: #103f5e;
}

.white-bg-sec {
  background-color: white;
  padding: 30px !important;
}

.grid-wrapper.border {
  border: 0px !important;
}

.table thead th {
  color: #939393;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-bottom: 0px;
}

.modal-content .modal-body {
  padding: 40px 82px 20px;
}

.table th,
.table td {
  border-top: 0px;
  border-radius: 5px;
}

.grouping {
  justify-content: center;
  justify-items: center;
  text-align: center;
  align-items: center;
  align-content: center;
}

.break {
  width: 100%;
  height: 2px;
  background-color: #f3f3f3;
  margin: 40px 0px 50px 0px;
}
.break-sections {
  width: 1076px !important;
  height: 1px !important;
  opacity: 0.08;
  background-color: #000000 !important;
  margin: 24px auto 28px auto;
}
.int-att-code {
  
  
  font-weight: 400;
  font-size: 16px !important;
  line-height: 19px;
  margin-inline-start: 33px;
  margin-bottom: 20px;
  color: #495057;
}
.sync-list {
  width: 81px;
  height: 19px;
  font-size: 16px;
  line-height: 19px;

  font-weight: 700;
  color: #939393;
}

.sync-logs {
  .btn-style {
    
    
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    text-align: center;

    /* #FFFFFF */

    color: #ffffff;
  }
}

.cards-con {
  margin: auto !important;
  width: 919px;
  height: 289px;
  box-sizing: border-box;
  background: #f3f3f3;
  border-radius: 18px;
}

// .container {
//   padding-top: 40px;
// }

.card-style {
  width: 188px;
  height: 187px;
  background: #ffffff;
  border-radius: 18px;
  .card-body {
    padding: 0px !important;

    .head-style {
      padding-top: 28px;
      padding-bottom: 16px;

      h4 {
        font-weight: 900 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        padding: 0px !important;
        margin: 0px !important;
        text-transform: uppercase;

        color: #c7c7c7 !important;
      }
    }
  }
}

.view-style {
  margin: auto !important;
  width: 60px !important;
  height: 25px !important;
  button.btn.d-flex.align-items-center.px-3.top-page-btn.btn-primary.btn-sm.rounded-pill {
    width: 60px !important;
    height: 25px !important;
    display: flex !important;
    align-items: center !important;
    border-radius: 12.5px !important;
    justify-content: center !important;
  }
  button.btn.d-flex.grouping.align-items-center.px-3.top-page-btn.btn-primary.btn-sm.rounded-pill.disabled {
    width: 60px !important;
    height: 25px !important;
    display: flex !important;
    align-items: center !important;
    border-radius: 12.5px !important;
    justify-content: center !important;
  }
  button.btn.grouping.align-items-center.px-3.top-page-btn.btn-primary.btn-sm.rounded-pill.disabled {
    width: 60px !important;
    height: 25px !important;
    display: flex !important;
    align-items: center !important;
    border-radius: 12.5px !important;
    justify-content: center !important;
  }
}

.icon-style {
  height: 55px;
  align-items: center;
}

.table-style {
  width: 100% !important;
}

.header-close {
  color: #f2f2f2;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5 {
  
  
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 30px;
  color: #939393;
}

h5.modal-title {
  width: 100%;
  
  
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.25px;
  color: #000000;
  margin-bottom: 0px !important;
}

.add-user-icon {
  font-size: 1.5rem;
  color: #103f5e;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    color: #34c38f;
  }

  table tr {
    border-bottom: 4px solid red !important;
  }

  .popover-modal {
    position: absolute;
    width: 300px !important;
    height: 359px;
    inset-inline-start: 373px;
    top: 270px;

    background: #ffffff;
    border-radius: 26px;
  }
}
</style>
<style lang="scss">
//integration()
div#dxAttCodeGride {
  .dx-datagrid .dx-row > td {
    color: #495057 !important;
  }
}
div#actionWarning___BV_modal_content_ {
  width: 579px !important;
  height: 302px !important;

  h4.modal-title {
    
    
    font-weight: 700;
    font-size: 16px !important;
    line-height: 20px;
    color: #000000;
    text-align: start !important;
    margin-bottom: 35px !important;
  }

  .modal-paragraph {
    
    
    font-weight: 400;
    font-size: 20px !important;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;

    .bold-word {
      font-weight: 700 !important;
    }
  }

  .modal-smallParagraph {
    
    
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #939393;
    margin-bottom: 21px !important;
  }

  .line {
    width: 488.16px !important;
    height: 1px !important;
    opacity: 0.15;
    background: #707070;
  }

  .modal-buttonSize {
    width: 111.69px !important;
    height: 33.26;
    margin-top: 20px !important;
    margin-bottom: 19.75px !important;
  }
}

div#syncLogsModal___BV_modal_content_ {
  h5.modal-title {
    margin-bottom: 41px;
  }

  .header-close-style {
    margin-bottom: 41px;
  }
}
</style>
